import { render, staticRenderFns } from "./MSPointClaimingSetting.vue?vue&type=template&id=556e58b4&"
import script from "./MSPointClaimingSetting.vue?vue&type=script&lang=js&"
export * from "./MSPointClaimingSetting.vue?vue&type=script&lang=js&"
import style0 from "./MSPointClaimingSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports